import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { AddplantService } from 'src/app/services/addplant.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Customerservice } from 'src/app/model/customerservice.model';
import { CustomergroupService } from 'src/app/services/customergroup.service';

@Component({
  standalone: false,
  selector: 'app-update-new-customer',
  templateUrl: './update-new-customer.component.html',
  styleUrls: ['./update-new-customer.component.scss']
})
export class UpdateNewCustomerComponent implements OnInit {

  @ViewChild('usergroups', { static: false }) input: any;

  public customerservice = new Customerservice();
  private subscriptions = new Subscription();

  prakList: any = [];
  public formData: any;
  finalSubmissionArray = [];
  mainGroups = [];
  mainUserList = [];
  selectedGroupIds = [];
  selectedParkIds = [];
  onlyGroupIdsArray = [];
  memberId: any;
  memberDetails: any;
  userSelectedGroupIds = [];
  userSelectedParkIds = [];
  groupSelectFocused: boolean = true;
  parkSelectFocused: boolean = true;

  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];

  myForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private customergroupService: CustomergroupService,
  ) {
    this.myForm = this.formBuilder.group({
      newUsersGroups: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavLand', 'true');
    const routepos = this.sideNavService.routingChunks({
      name: 'Users',
      subNav: '0',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routepos);
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.memberId = params['id'];
    });

    this.customerservice.ParkId = '';
    this.customerservice.groupId = '';
    this.customerservice.userId = '';
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    this.getParkDetails();
    this.getTheMainServiceGroupList();
    this.getTheMainClaUserList();

    this.getMemberDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.customergroupService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  onSubmit() {
    if (this.myForm.valid) {

      this.finalSubmissionArray = [];

      // for (let i = 0; i <= this.myForm.value.newUsersGroups.length - 1; i++) {
      //   this.finalSubmissionArray.push({
      //     'groupIds': this.myForm.value.newUsersGroups[i].groupid,
      //     'parkIds': this.myForm.value.newUsersGroups[i].parkid,
      //     // 'userName': this.mainUserList.filter(obj => { return obj.memberId == this.myForm.value.newUsersGroups[i].userid })[0]['memberName'],
      //     // 'userId': this.myForm.value.newUsersGroups[i].userid,
      //     'claId': 0,
      //     'createdBy': localStorage.getItem('claAdminId'),
      //   });
      // }

      this.finalSubmissionArray.push({
        'groupIds': this.myForm.value.newUsersGroups[0].groupid,
        'parkIds': this.myForm.value.newUsersGroups[0].parkid,
        // 'userName': this.mainUserList.filter(obj => { return obj.memberId == this.myForm.value.newUsersGroups[i].userid })[0]['memberName'],
        // 'userId': this.myForm.value.newUsersGroups[i].userid,
        'claId': this.memberId,
        'createdBy': localStorage.getItem('claAdminId'),
      });

      console.log(this.finalSubmissionArray);

      this.customergroupService
        .updateNewCustomerServiceUser(this.finalSubmissionArray[0])
        .subscribe((res) => {
          if (res?.isValid === true) {
            this.router.navigate(['/list-customer-service-user/']);
          }
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  newUsersGroups(): FormArray {
    return this.myForm.get('newUsersGroups') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      parkid: ['', Validators.required],
      groupid: ['', Validators.required],
      userid: ['', Validators.required],
    });
  }

  addMore(): void {
    this.newUsersGroups().push(this.newNotes());
    this.selectedGroupIds.length = 0;
  }

  removeBlock(i: number) {
    this.newUsersGroups().removeAt(i);
  }

  getTheMainServiceGroupList() {
    this.customergroupService.getMainGroupList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainGroups = res?.list;
        for (let i = 0; i <= this.mainGroups.length - 1; i++) {
          this.onlyGroupIdsArray.push(this.mainGroups[i].groupId);
        }
        // console.log(this.onlyGroupIdsArray);
      }
    });
  }

  getTheMainClaUserList() {
    this.customergroupService.claUserList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainUserList = res?.list;
      }
    });
  }

  selectGroupData(e) {
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedGroupIds.push(e[i].groupId);
    }
    this.selectedGroupIds = this.selectedGroupIds.filter((value, index, array) => array.indexOf(value) === index);
  }

  selectParkData(e) {
    for (let i = 0; i <= e.length - 1; i++) {
      this.selectedParkIds.push(e[i].parkId);
    }
    this.selectedParkIds = this.selectedParkIds.filter((value, index, array) => array.indexOf(value) === index);
  }

  clearSelectedData() {
    this.selectedGroupIds.length = 0;
  }

  clearSelectedDataPark() {
    this.selectedParkIds.length = 0;
  }

  getMemberDetails() {
    this.customergroupService.getMemberDetailsSingle(this.memberId).subscribe((res) => {
      if (res?.isValid === true) {
        this.memberDetails = res;
        this.customerservice.userid = this.memberDetails.data?.memberId;
        for (let i = 0; i <= this.memberDetails.data?.serviceGroups.length - 1; i++) {
          this.userSelectedGroupIds.push(this.memberDetails.data?.serviceGroups[i].groupId);
        }
        for (let i = 0; i <= this.memberDetails.data?.parks.length - 1; i++) {
          this.userSelectedParkIds.push(this.memberDetails.data?.parks[i].parkId);
        }
        this.customerservice.userSelectedGroupIds = this.userSelectedGroupIds;
        this.customerservice.userSelectedParkIds = this.userSelectedParkIds;
        console.log(this.userSelectedGroupIds);
        console.log(this.userSelectedParkIds);
      }
    });
  }

  goToListPage() {
    this.router.navigate(['/list-customer-service-user/']);
  }

  onGroupSelectOpen(index) {
    console.log(index);
    this.groupSelectFocused = true;
  }

  onParkSelectOpen(index) {
    console.log(index);
    this.parkSelectFocused = true;
  }

}
